import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit {
  isNavVisible: boolean = false;

  constructor() { }

  ngOnInit() {

  }

  toggleNav() {
    if (this.isNavVisible) {
      this.isNavVisible = false;
    } else {
      this.isNavVisible = true;
    }
  }

  closeNav() {
    this.isNavVisible = false;
  }
}
